import type { GridView } from "@appretio/shared";
import { IconButton } from "@appretio/ui-kit";

/** The tooltip for the default toggle, in both states. */
export interface SetDefaultTitles {
  /** When the applied view already is the default. */
  current: string;
  /** When clicking would make it the default. */
  promote: string;
}

interface SetDefaultViewButtonProps {
  /** The applied saved view. ``undefined`` hides the button. */
  view?: GridView;
  /** Promotes the view to the one the page opens with. */
  onSetDefault: (viewId: string) => void;
  /** Whether the promotion is in flight. */
  isPending: boolean;
  /** What the default means for this list. */
  titles: SetDefaultTitles;
}

/**
 * Crosshair toggle that makes the applied view the default of its list,
 * mirroring the version selector's main-version control. Disabled when it
 * already is — one default per user and list.
 */
export function SetDefaultViewButton({
  view,
  onSetDefault,
  isPending,
  titles
}: SetDefaultViewButtonProps) {
  if (!view) return null;

  const title = view.is_default ? titles.current : titles.promote;

  return (
    <IconButton
      iconName="crosshair"
      variant="tertiary"
      size="xs"
      disabled={view.is_default || isPending}
      isLoading={isPending}
      onClick={() => onSetDefault(view.view_id)}
      title={title}
      aria-label={title}
    />
  );
}
